import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ForbiddenHttpInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap({
      error: err => {
        if (err.status === 403) {
          this.router.navigate(['/settings/account/profile']);
        }
      }
    }));
  }
}
